module.exports = "<div>\n  <button class=\"btn btn-default\" role=\"button\" (click)=\"goBack()\"><span class=\"fa fa-arrow-left\"></span> Atrás</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/common/back/back.component.html
// module id = ../../../../../src/app/common/back/back.component.html
// module chunks = 1